import React from 'react'
import { Button, Form, Image } from 'react-bootstrap'
import i18next from 'i18next'

import styles from './brand_image.module.css'
const { t } = i18next
const MIME_TYPES = ['image/jpeg', 'image/png', 'image/svg+xml']

class BrandImage extends React.PureComponent {
  static defaultProps = {
    tenant: '',
    type: '',
    brand_img: '',
    id: '',
    readonly: false,
    custom_img_style: {},
    onChange: () => {},
  }

  inputRef = null

  constructor(props) {
    super(props)
    this.inputRef = React.createRef()
    let base_url = 'api/brands'
    if (props?.brand_img?.indexOf('data:') !== -1) {
      this.state.brand_img = props.brand_img
    } else {
      this.state.brand_img = props.brand_img !== '' ? `${base_url}/${props.id}/image` : ''
    }
  }

  state = {
    brand_img: '',
    file_error: '',
  }

  componentDidUpdate(prevProps) {
    let base_url = 'api/brands'
    if (prevProps.brand_img !== this.props.brand_img) {
      if (this.props?.brand_img === '' || this.props?.brand_img?.indexOf('data:') !== -1) {
        this.setState({ brand_img: this.props.brand_img })
      } else {
        this.setState({
          brand_img: `${base_url}/${this.props.id}/image`,
        })
      }
    }
  }

  handleFileChange = ({ target }) => {
    if (!target?.files.length) {
      this.setState({ file_error: '' })
      return
    }
    if (!MIME_TYPES.includes(target.files[0].type)) {
      this.setState({ file_error: t('theme.unsupported_file_format', 'Tipo di file non supportato') })
      return
    }
    if (target.files[0].size > 15048000) {
      this.setState({ file_error: t('theme.file_too_large', 'File troppo grande') })
      return
    }

    const reader = new FileReader()
    reader.onload = () => {
      this.setState({ brand_img: reader.result, file_error: '' }, () => {
        this.props.onChange(this.state.brand_img)
      })
    }
    reader.readAsDataURL(target.files[0])
  }

  handleEdit = () => {
    this.inputRef.current.click()
  }

  handleDelete = () => {
    this.inputRef.current.value = ''
    this.setState({ brand_img: '', file_error: '' }, () => {
      this.props.onChange(this.state.brand_img)
    })
  }

  render() {
    let { readonly, custom_img_style } = this.props
    let { brand_img, file_error } = this.state
    let src = brand_img !== '' ? `${brand_img}` : 'no_img.jpg'

    return (
      <>
        {readonly === false && (
          <Form.Control
            hidden={true}
            ref={this.inputRef}
            type="file"
            accept={MIME_TYPES.join(',')}
            isInvalid={file_error}
            onChange={this.handleFileChange}
          />
        )}
        <div className={styles.img_container} style={{ ...custom_img_style }}>
          <Image
            className={readonly === false ? styles.image : styles.image_readonly}
            role={readonly === false ? 'button' : ''}
            onClick={this.handleEdit}
            alt={t('components.brands.logo', 'Logo brand')}
            src={src}
            thumbnail
          />
        </div>
        <Form.Control.Feedback className="text-center" type="invalid">
          {file_error}
        </Form.Control.Feedback>
        {brand_img !== '' && readonly === false && (
          <div className="d-flex align-items-center text-center" style={{ width: '13rem' }}>
            <Button onClick={this.handleDelete} variant="link" className="col text-danger p-0">
              Elimina
            </Button>
          </div>
        )}
      </>
    )
  }
}

export default BrandImage
